var loading = function(abrir) {
    if (abrir) {
        document.getElementById('all-loading').classList.add('show');
    } else {
        document.getElementById('all-loading').classList.remove('show');
    }
}

export default loading
